import React, {
    useState,
    useEffect,
	useContext
} from "react";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import BuildingDrawer from "./components/BuildingDrawer";
import FloorTool from "./components/FloorTool";
import TitleGlassPill from "../../components/TitleGlassPill";
import FloorSpacePlan from "./components/FloorSpacePlan";
import {useParams} from "react-router-dom";


import { useHistory } from "react-router-dom";
import { JWT } from "../../constants/local-storage";
import FloorSvg
    from "../../pages/floorplan/components/FloorSvg";
import { functions }
    from "../../constants/common-functions";
	
import { store }
    from "../../context/store.js";
	
import MobileSpaceOrgBuilding
	from "./mobile/MobileSpaceOrgBuilding";
	
	
export default function SpaceOrgDashboard()
{
	
	const facilityId = useParams()["facilityId"];
	
	const [buildingName, setBuildingName] = useState("");
	const [selectedFloorId, setSelectedFloorId] =
		    useState(-1);

	
	useEffect(() => {
			
	  functions.getObjectFromAjax(
	    "/resolutionsoftwareplatform/spaceorgfacilityloadinitial?facilityId=" + facilityId,
	    handleFacilityResponse,
	  );

	}, [facilityId]); 
	
	
	const handleFacilityResponse = (obj) => {
		if(obj && obj.facilityName){
			setBuildingName(obj.facilityName);
			setSelectedFloorId(obj.floorId);
		}
	}
	
	
	const [
	    floorToolExpanded,
	    setFloorToolExpanded
	] =
	useState(false);
	

	const [selectedSpaceId, setSelectedSpaceId] =
	    useState(null);
		
	const [selectedSpaceTypeId, setSelectedSpaceTypeId] =
		    useState(null);
	
	
	const globalState =
	        useContext(store);
			
	const client =
	       globalState
	       && globalState.state
	           ? globalState.state.client
	           : null;
	
	const history = useHistory();
	
	
	

    /* =========================
       STYLES
    ========================== */

    const thisContainer =
    {
        display: "flex",
        position: "fixed",
        flexDirection: "column",
        width: "100%",
        minHeight: "100vh",
        left: "0px",
        top: "0px"
    };

    const mainContainer =
    {
        display: "flex",
        position: "fixed",
        top: "0px",
        left: "60px",
        bottom: "0px",
        right: "0px",
        overflow: "hidden"
    };

    const contentArea =
    {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    };

    const kpiContainer =
    {
        position: "absolute",
        top: "20px",
        left: "20px",
        right: "450px",
        height: "90px",
        display: "flex",
        gap: "15px"
    };

    const kpiCard =
    {
        flex: 1,

        background:
            "linear-gradient(135deg,#1f2937,#111827)",

        borderRadius: "15px",

        boxShadow:
            "0 10px 25px rgba(0,0,0,0.15)",

        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    };

    const kpiValue =
    {
        fontSize: "24px",
        fontWeight: "bold",
        color: "#5a9bd6"
    };

    const kpiLabel =
    {
        fontSize: "12px",
        color: "#ffffff",
        marginTop: "5px"
    };

    const chartContainer =
    {
        position: "absolute",

        top: "130px",
        left: "20px",
        right: "430px",
        bottom: "30px"

        // background intentionally omitted
    };

  

    const overlayStyle =
    {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(255,255,255,0.85)",
        pointerEvents: "none",
        opacity: 0,
        animation: "fadeOverlay 4s ease forwards"
    };
	
	const floorPlanContainer =
	{
	    position: "absolute",

	    top: "0px",
	    left:
	        floorToolExpanded
	            ? "0px"
	            : "430px",

	    right: "0px",
	    bottom: "00px",

	    borderRadius: "0px",

	    background: "white",

	    border:
	        "1px solid #EEF1F5",

	    boxShadow:
	        "0 1px 2px rgba(0,0,0,0.04)",

	    overflow: "hidden",

	    transition:
	        "all 0.3s ease"
	};
	
	function handleToggleFloorTool()
	{
	    setFloorToolExpanded(
	        !floorToolExpanded
	    );
	}
	
	
	//--------------------------------------------------------
	   // Mobile
	   //--------------------------------------------------------

	   const isMobile =
	       window.innerWidth <= 768;

	   if(isMobile)
	   {
	       return (
	           <MobileSpaceOrgBuilding />
	       );
	   }

    /* =========================
       RENDER
    ========================== */

    return (
        <div style={thisContainer}>

            <Header transitionHide={true}/>

            <LeftMenu />

            <div style={overlayStyle} />

           

            <div style={mainContainer}>

                <div style={contentArea}>

                  
				
				<div style={floorPlanContainer}>
				<FloorSpacePlan

				    key={selectedFloorId}

				    floorId={selectedFloorId}

				    colourMode="spaceType"

				    selectedSpaceId={selectedSpaceId}

				    setSelectedSpaceId={setSelectedSpaceId}

				    selectedSpaceTypeId={selectedSpaceTypeId}

				    setSelectedSpaceTypeId={setSelectedSpaceTypeId}

				    onSpaceClick={
				        function(space)
				        {
				            console.log(
				                "Selected space",
				                space
				            );
				        }
				    }

				/>
				</div>
					{/* LEFT DRAWER */}

					<BuildingDrawer
						expanded={floorToolExpanded}
						onToggle={handleToggleFloorTool}
						facilityId={facilityId}
						setSelectedFloorId={setSelectedFloorId}
					/>
					
                </div>
				
            </div>
			{/* BUILDING TITLE */}
			<TitleGlassPill label={buildingName}/>
			<FloorTool
			floorId={selectedFloorId}
			    expanded={floorToolExpanded}
			    onToggle={handleToggleFloorTool}
				selectedSpaceTypeId={selectedSpaceTypeId}
				setSelectedSpaceId={setSelectedSpaceId}
				setSelectedSpaceTypeId={setSelectedSpaceTypeId}
			/>
        </div>
    );
}